import React, { useEffect, useState } from "react";
import { useStripe } from "@stripe/react-stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import stripePromise from "../../utils/stripe";
import { Box, Button, LinearProgress, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InfoIcon from "@mui/icons-material/Info";
import ErrorIcon from "@mui/icons-material/Error";
import { useNavigate } from "react-router-dom";
export default function PaymentStatus() {
	const [clientSecret, setClientSecret] = useState();
	const [couponMessage, setCouponMessage] = useState();
	const navigate = useNavigate();
	const goHome = () => {
		navigate("/record-history");
	};
	useEffect(() => {
		setClientSecret(new URLSearchParams(window.location.search).get("payment_intent_client_secret"));
		setCouponMessage(new URLSearchParams(window.location.search).get("coupon_message"));
	}, []);
	const getPaymentStatus = (status) => {
		switch (status) {
			case "succeeded":
				return (
					<Box textAlign={"center"}>
						<CheckCircleIcon color="success" sx={{ fontSize: 50 }} />
						<Typography variant="h4" gutterBottom>
							Your payment has been successfully processed.
						</Typography>
						<Typography>In within 24 hours you will receive an email notifying you about your Criminal Record Check requested.</Typography>
						<Typography>If there are any issues or concerns, please email us at support@policecerts.com.</Typography>
						<Button variant="outlined" style={{ textTransform: "capitalize", marginTop: 16 }} onClick={goHome}>
							Done
						</Button>
					</Box>
				);

			case "processing":
				return (
					<Box textAlign={"center"}>
						<InfoIcon color="info" sx={{ fontSize: 50 }} />
						<Typography variant="h4" gutterBottom>
							Your payment is processing.
						</Typography>
						{/* <Typography>In within 24 hours you will receive an email notifying you about your Criminal Record Check requested.</Typography>
							<Typography>If there are any issues or concerns, please email us at support@policecerts.com.</Typography> */}
						<Button variant="outlined" style={{ textTransform: "capitalize", marginTop: 16 }} onClick={goHome}>
							Done
						</Button>
					</Box>
				);

			case "requires_payment_method":
				return (
					<Box textAlign={"center"}>
						<ErrorIcon color="error" sx={{ fontSize: 50 }} />
						<Typography variant="h4" gutterBottom>
							Your payment was not successful, please try again.
						</Typography>
						{/* <Typography>In within 24 hours you will receive an email notifying you about your Criminal Record Check requested.</Typography>
							<Typography>If there are any issues or concerns, please email us at support@policecerts.com.</Typography> */}
						<Button variant="outlined" style={{ textTransform: "capitalize", marginTop: 16 }} onClick={goHome}>
							Done
						</Button>
					</Box>
				);

			default:
				return (
					<Box textAlign={"center"}>
						<ErrorIcon color="error" sx={{ fontSize: 50 }} />
						<Typography variant="h4" gutterBottom>
							Something went wrong
						</Typography>
						{/* <Typography>In within 24 hours you will receive an email notifying you about your Criminal Record Check requested.</Typography>
							<Typography>If there are any issues or concerns, please email us at support@policecerts.com.</Typography> */}
						<Button variant="outlined" style={{ textTransform: "capitalize", marginTop: 16 }} onClick={goHome}>
							Done
						</Button>
					</Box>
				);
		}
	};
	return (
		<Box>
			<LinearProgress variant="determinate" value={100} style={{ marginBottom: "20px", position: "absolute", top: "101px", left: "0", width: "100%" }} />
			{clientSecret ? (
				<Elements options={{ clientSecret }} stripe={stripePromise}>
					<PaymentStatusContent getPaymentStatus={getPaymentStatus} />
				</Elements>
			) : (
				getPaymentStatus(couponMessage)
			)}
		</Box>
	);
}
function PaymentStatusContent({ getPaymentStatus }) {
	const [message, setMessage] = useState(null);
	const stripe = useStripe();
	useEffect(() => {
		if (!stripe) {
			return;
		}

		const clientSecret = new URLSearchParams(window.location.search).get("payment_intent_client_secret");

		if (!clientSecret) {
			return;
		}
		const couponMessage = new URLSearchParams(window.location.search).get("coupon_message");
		if (couponMessage) {
			setMessage(getPaymentStatus(couponMessage));
			return;
		}
		stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
			setMessage(getPaymentStatus(paymentIntent.status));
		});
	}, [stripe]);
	return <>{message}</>;
}
